











































import Vue from 'vue'
import FullModalLayout from '@/components/modal/basics/FullModal/FullModalLayout.vue'
import FullModalHeaderCloseButton from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderCloseButton.vue'
import FullModalHeaderTitle from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderTitle.vue'
import FacilityNameSearchInput from './FacilityNameSearchInput.vue'
import SearchHistoryList from '@/components/modal/SearchFacilityModal/SearchHistoryList.vue'

export default Vue.extend({
  components: {
    FullModalLayout,
    FullModalHeaderCloseButton,
    FullModalHeaderTitle,
    FacilityNameSearchInput,
    SearchHistoryList,
  },
  filters: {},
  props: {
    name: {
      type: String,
      default: 'SearchByNameModal',
    },
    submitText: {
      type: String,
      default: '検索結果を表示',
    },
    facilityNameHistory: {
      type: Array as () => string[],
      default: () => [],
    },
  },
  data() {
    return {
      facilityName: null as string | null,
    }
  },
  computed: {},
  methods: {
    onClose() {
      this.$modal.pop()
      this.$emit('onClose')
      this.facilityName = null
    },
    onSubmit() {
      this.$emit('submit', this.facilityName)
      this.facilityName = null
    },
  },
})
